/**
* Hero Card Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Card Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hero-card-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      let totalCards = $( '.hero-card-slider .card' ).length;
      let z = $( '.hero-card-slider .card' ).length;
      let pastCards = 0;
      let totalCardsStatic = $( '.hero-card-slider .card' ).length;
      const currTotalCards = totalCardsStatic;
      let beenClicked = false;
      let forcePause = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ? true : false;
      let isTab = false;
      const autoplaySpeed = 5000;
      const cardWidth = 395;
      const marginWidth = 50;
      let cardOffsetCount = 2;
      let initialFirstPos = $( 'body' ).width();

      if ( window.innerWidth > 1023 ) {
        initialFirstPos = $( 'body' ).width() / 2;
      }

      $( window ).resize( function() {
        initialFirstPos = $( 'body' ).width();

        if ( window.innerWidth > 1023 ) {
          initialFirstPos = $( 'body' ).width() / 2;
        }
      } );

      if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
        $( '.hero-card-slider .card' ).attr( 'aria-live', 'off' );
      }

      // Pause if the user starts tabbing
      document.addEventListener( 'keydown', function( e ) {
        if ( e.keyCode === 9 ) {
          isTab = true;
        }
      } );

      $( document ).on( 'keyup', function( e ) {
        if ( e.keyCode === 9 && isTab ) {
          isTab = false;
        }
      } );

      $( '.hero-card-slider' ).on( 'focusin', function( e ) {
        if ( $( e.target ).closest( '.hero-card-slider' ).length && !beenClicked ) {
          beenClicked = true;
          window.clearInterval( autorotate ); // pause
        }
      } );


      // document.addEventListener( 'click', function( e ) {
      //   if ( e.target.localName !== 'a' && e.target.localName !== 'button' ) {
      //     isNotTabbing();
      //   }
      // } );

      function isTabbing() {
        $( '.hero-card-slider .card:not(.is-active), .hero-card-slider .card:not(.is-active) *' ).addClass( 'pointer-events-none' ).attr( 'tabindex', '-1' );
      }

      function isNotTabbing() {
        $( '.hero-card-slider .card:not(.is-active)' ).removeClass( 'pointer-events-none' ).attr( 'tabindex', '0' );
        $( '.hero-card-slider .card:not(.is-active) *' ).removeClass( 'pointer-events-none' ).removeAttr( 'tabindex' );
      }

      // If there's not enough cards to fill the card row,
      // clone some to make it look like there are
      if ( totalCardsStatic < 4 ) {
        for ( let i = 0; i < currTotalCards; i++ ) {
          const cardHTML = $( '.hero-card-slider .card' )[i];
          $( '.hero-card-slider .cards' ).append( $( '.hero-card-slider .card:nth-child(' + ( i + 1 ) + ')' ).clone() );
          // console.log( $( '.hero-card-slider .cards .card:nth-child(' + ( i + 1 ) + ')' ).attr( 'data-original' ) );
          $( '.hero-card-slider .cards .card:last-child' ).addClass( 'is-cloned' ).removeClass( 'is-active' ).css( 'z-index', i + 1 + currTotalCards ).attr( 'data-original', parseInt( $( '.hero-card-slider .cards .card:nth-child(' + ( i + 1 ) + ')' ).attr( 'data-original' ) ) + currTotalCards ).attr( 'data-key', parseInt( $( '.hero-card-slider .cards .card:nth-child(' + ( i + 1 ) + ')' ).attr( 'data-key' ) ) + currTotalCards );
          $( '.hero-card-slider .cards .card:last-child' ).find( 'a, button' ).attr( 'tabindex', -1 );
          $( '.hero-card-slider .cards .card:last-child' ).attr( 'aria-hidden', 'true' );
          z++;
          totalCardsStatic++;
        }
      }

      setUpCards();

      $( '.hero-card-slider .slider-next' ).click( function( e ) {
        if ( $( this ).is( ':disabled' ) ) {
          return;
        }

        window.clearInterval( autorotate );
        goToNextSlide( e );
      } );

      $( '.hero-card-slider .slider-prev' ).click( function( e ) {
        if ( $( this ).is( ':disabled' ) ) {
          return;
        }

        goToPrevSlide( e );
      } );

      // Mobile touch swipe support
      let touchStartX = 0;
      let touchStartY = 0;
      const swipeThreshold = 50;

      $( '.hero-card-slider' ).on( 'touchstart', function( e ) {
        touchStartX = e.originalEvent.touches[0].clientX;
        touchStartY = e.originalEvent.touches[0].clientY;
      } );

      $( '.hero-card-slider' ).on( 'touchend', function( e ) {
        const deltaX = e.originalEvent.changedTouches[0].clientX - touchStartX;
        const deltaY = e.originalEvent.changedTouches[0].clientY - touchStartY;

        if ( Math.abs( deltaX ) < swipeThreshold || Math.abs( deltaX ) < Math.abs( deltaY ) ) {
          return;
        }

        beenClicked = true;
        window.clearInterval( autorotate );

        if ( deltaX < 0 ) {
          goToNextSlide();
        } else {
          goToPrevSlide();
        }
      } );

      // Setup the autoplay
      let autorotate = window.setInterval( function() {
        if ( !beenClicked && !forcePause ) {
          goToNextSlide();
        }
      }, autoplaySpeed );

      // Pause the autoplay if hovered
      $( document ).on( 'mouseover', '.hero-card-slider .slider-nav, .hero-card-slider .card:not( .is-active ), .hero-card-slider .card.is-active .card-wysiwyg', function() {
        $( '.hero-card-slider' ).addClass( 'is-paused' );
        window.clearInterval( autorotate ); // pause
      } ).on( 'mouseleave', '.hero-card-slider .slider-nav, .hero-card-slider .card:not( .is-active ), .hero-card-slider .card.is-active .card-wysiwyg', function() {
        $( '.hero-card-slider' ).removeClass( 'is-paused' );
        resumeToNextSlide();
      } );

      // Set up the initial positions of cards
      function setUpCards() {
        const newCards = $( '.hero-card-slider .card' );
        $( newCards ).each( function( key, val ) {
          if ( key == 1 ) {
            $( newCards[key] ).css( 'left', initialFirstPos );
          } else if ( key > 1 ) {
            const newPos = initialFirstPos + ( ( parseInt( cardWidth ) + marginWidth ) * ( key - 1 ) );
            $( newCards[key] ).css( 'left', newPos );
          }
        } );

        $( '.hero-card-slider .card' ).css( 'opacity', 1 );
      }

      // Set up the positions of cards when the previous button is clicked
      function setUpPrevCards( newCardKey ) {
        pastCards--;
        totalCards--;
        cardOffsetCount--;

        let newCardOriginal = newCardKey;
        if ( newCardOriginal == 0 ) {
          newCardOriginal = totalCardsStatic;
        }
        $( '.hero-card-slider .slider-prev, .hero-card-slider .slider-next' ).addClass( 'pointer-events-none' );
        $( '.hero-card-slider .slider-next' ).removeAttr( 'disabled' );
        const newCardsRaw = $( '.hero-card-slider .card' ).not( '.is-past, .is-active' );
        $( '.hero-card-slider .progress-bar .tracker' ).css( 'width', ( ( $( '.hero-card-slider .card[data-original=' + ( newCardOriginal ) + ']' ).attr( 'data-original' ) / totalCardsStatic ) * 100 ) + '%' );
        $( ' .hero-card-slider .pagination .current' ).text( $( '.hero-card-slider .card[data-original=' + ( newCardOriginal ) + ']' ).attr( 'data-original' ) );

        const newCards = [];
        $( newCardsRaw ).each( function( key, val ) {
          newCards[parseInt( $( val ).attr( 'data-key' ) ) - cardOffsetCount] = val;
        } );

        $( newCards ).each( function( key, val ) {
          if ( key == 0 ) {
            $( newCards[key] ).css( 'left', initialFirstPos );
          } else if ( key > 0 ) {
            const newPos = initialFirstPos + ( ( parseInt( cardWidth ) + marginWidth ) * key );
            $( newCards[key] ).css( 'left', newPos );
          }
        } );
        $( '.hero-card-slider .card.is-active' ).focus();

        if ( cardOffsetCount == 2 ) {
          $( '.hero-card-slider .slider-prev' ).attr( 'disabled', 'true' );
        } else {
          $( '.hero-card-slider .slider-prev' ).removeAttr( 'disabled' );
        }

        setTimeout( function() {
          $( '.hero-card-slider .slider-prev, .hero-card-slider .slider-next' ).removeClass( 'pointer-events-none' );
        }, 1000 );
      }

      const removalNumber = ( totalCardsStatic + 1 ) * 2;

      // Set up the positions of cards when the next button is clicked
      function setUpNextCards( newCardKey, goTo = false ) {
        cardOffsetCount++;
        $( '.hero-card-slider .slider-prev, .hero-card-slider .slider-next' ).addClass( 'pointer-events-none' );
        let initCardKey = newCardKey;
        if ( initCardKey == 0 ) {
          initCardKey = 1;
        }
        pastCards++;
        z++;
        totalCards++;

        $( '.hero-card-slider .slider-prev' ).removeAttr( 'disabled' );

        if ( $( '.hero-card-slider .card[data-key=' + ( initCardKey - 1 ) + ']' ).length ) {
          $( '.hero-card-slider .card[data-key=' + ( initCardKey - 1 ) + ']' ).removeClass( 'is-past' ).attr( 'data-key', parseInt( $( '.hero-card-slider .card[data-key=' + ( initCardKey - 1 ) + ']' ).attr( 'data-key' ) ) + totalCardsStatic );
        }

        const newCardsRaw = $( '.hero-card-slider .card' ).not( '.is-past, .is-active' );
        $( '.hero-card-slider .progress-bar .tracker' ).css( 'width', ( ( $( '.hero-card-slider .card[data-key=' + ( initCardKey + 1 ) + ']' ).attr( 'data-original' ) / totalCardsStatic ) * 100 ) + '%' );
        $( ' .hero-card-slider .pagination .current' ).text( $( '.hero-card-slider .card[data-key=' + ( initCardKey + 1 ) + ']' ).attr( 'data-original' ) );

        const newCards = [];
        $( newCardsRaw ).each( function( key, val ) {
          newCards[parseInt( $( val ).attr( 'data-key' ) ) - cardOffsetCount] = val;
        } );


        let initialPrevCardPos = 0;
        $( newCards ).each( function( key, val ) {
          if ( key == 0 ) {
            $( newCards[key] ).css( 'left', initialFirstPos );
          } else if ( key > 0 ) {
            const newPos = initialFirstPos + ( ( parseInt( cardWidth ) + marginWidth ) * key );
            $( newCards[key] ).css( 'left', newPos );
            initialPrevCardPos = newPos;
          }
        } );

        $( '.hero-card-slider .card[data-key=' + ( initCardKey + totalCardsStatic - 1 ) + ']' ).css( 'left', initialPrevCardPos + ( parseInt( cardWidth ) + marginWidth ) );
        setTimeout( function() {
          $( '.hero-card-slider .card[data-key=' + ( initCardKey + totalCardsStatic - 1 ) + ']' ).css( 'z-index', z );
        }, 1000 );
        z++;

        if ( newCards.length == 0 ) {
          $( '.hero-card-slider .slider-next' ).attr( 'disabled', 'true' );
        } else {
          $( '.hero-card-slider .slider-next' ).removeAttr( 'disabled' );
        }

        setTimeout( function() {
          $( '.hero-card-slider .slider-prev, .hero-card-slider .slider-next' ).removeClass( 'pointer-events-none' );
        }, 1000 );
      }

      // Pause the autoplay when scrolled away
      $( '.hero-card-slider' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 200px',
            end: 'bottom top',
            scrub: 0,
            onLeave: ( {progress, direction, isActive} ) => {
              window.clearInterval( autorotate );
            },
            onEnterBack: ( {progress, direction, isActive} ) => {
              resumeToNextSlide();
            },
          },
        } );
      } );

      function resumeToNextSlide() {
        if ( !forcePause ) {
          window.clearInterval( autorotate );
          autorotate = window.setInterval( function() {
            goToNextSlide();
          }, autoplaySpeed );
        }
      }

      function goToNextSlide() {
        const currSlide = $( '.hero-card-slider .card.is-active' )[0];
        let nextSlide = $( '.hero-card-slider .card.is-active' ).next()[0];

        if ( $( nextSlide ).length == 0 ) {
          nextSlide = $( '.hero-card-slider .card.card--1' )[0];
        }
        // set up the new next card
        $( $( nextSlide ).next() ).addClass( 'is-next' ).attr( 'aria-hidden', false );
        $( $( nextSlide ).next() ).find( '.card-content a, .card-content button' ).attr( 'tabindex', 0 );
        $( $( nextSlide ).next() ).find( '.main-content a, .main-content button' ).attr( 'tabindex', -1 );
        $( $( nextSlide ).next() ).find( '.main-content' ).attr( 'aria-hidden', true );
        $( $( nextSlide ).next() ).find( '.card-content' ).attr( 'aria-hidden', false );
        //  reset current main card
        $( currSlide ).removeClass( 'is-active' ).addClass( 'is-past' ).attr( 'aria-hidden', true ).find( 'a, button' ).attr( 'tabindex', -1 );
        $( currSlide ).find( 'a, button' ).attr( 'tabindex', -1 );
        // set up next card to be main card
        $( nextSlide ).removeClass( 'is-next' ).addClass( 'is-active' ).attr( 'aria-hidden', false ).css( 'left', 0 );
        $( nextSlide ).find( '.card-content a, .card-content button' ).attr( 'tabindex', -1 );
        $( nextSlide ).find( '.main-content a, .main-content button' ).attr( 'tabindex', 0 );
        $( nextSlide ).find( '.card-content' ).attr( 'aria-hidden', true );
        $( nextSlide ).find( '.main-content' ).attr( 'aria-hidden', false );

        setUpNextCards( $( nextSlide ).attr( 'data-key' ) - 1 );
      }

      function goToPrevSlide( e = {} ) {
        window.clearInterval( autorotate );
        const currSlide = $( '.hero-card-slider .card.is-active' )[0];
        const nextSlide = $( '.hero-card-slider .card.is-next' )[0];
        let prevSlide = $( '.hero-card-slider .card[data-key="' + ( parseInt( $( '.hero-card-slider .card.is-active' ).attr( 'data-key' ) ) - 1 ) + '"]' )[0];
        let prevPrevSlide = $( '.hero-card-slider .card[data-key="' + ( parseInt( $( '.hero-card-slider .card.is-active' ).attr( 'data-key' ) ) - 2 ) + '"]' )[0];

        if ( $( prevSlide ).length == 0 ) {
          prevSlide = $( '.hero-card-slider .card[data-key="' + ( parseInt( $( '.hero-card-slider .card.is-active' ).attr( 'data-key' ) ) + totalCardsStatic - 1 ) + '"]' )[0];
        }

        if ( $( prevPrevSlide ).length == 0 ) {
          prevPrevSlide = $( '.hero-card-slider .card[data-key="' + ( parseInt( $( '.hero-card-slider .card.is-active' ).attr( 'data-key' ) ) + totalCardsStatic - 2 ) + '"]' )[0];
        }

        $( nextSlide ).removeClass( 'is-next' ).attr( 'aria-hidden', 'true' );
        $( nextSlide ).find( 'a, button' ).attr( 'tabindex', -1 );

        $( currSlide ).addClass( 'is-next' ).removeClass( 'is-active' ).attr( 'aria-hidden', false );
        $( currSlide ).find( '.card-content a, .card-content button' ).attr( 'tabindex', 0 );
        $( currSlide ).find( '.main-content a, .main-content button' ).attr( 'tabindex', -1 );
        $( currSlide ).find( '.card-content' ).attr( 'aria-hidden', false );
        $( currSlide ).find( '.main-content' ).attr( 'aria-hidden', true );

        $( prevSlide ).addClass( 'is-active' ).removeClass( 'is-past' ).attr( 'aria-hidden', false );
        $( prevSlide ).find( '.main-content a, .main-content button' ).attr( 'tabindex', 0 );
        $( prevSlide ).find( '.main-content' ).attr( 'aria-hidden', false );
        $( prevSlide ).find( '.card-content' ).attr( 'aria-hidden', true );

        $( prevPrevSlide ).addClass( 'is-past' ).attr( 'aria-hidden', true ).css( 'z-index', parseInt( $( prevSlide ).css( 'z-index' ) ) - 1 ).attr( 'data-key', parseInt( $( prevSlide ).attr( 'data-key' ) ) - 1 ).find( 'a, button' ).attr( 'tabindex', -1 );
        $( prevPrevSlide ).find( 'a, button' ).attr( 'tabindex', -1 );
        z--;
        setTimeout( function() {
          $( prevPrevSlide ).addClass( 'is-past' ).css( 'left', 0 );
        }, 1000 );

        setUpPrevCards( $( currSlide ).index() );
      }

      $( document ).on( 'click', '.hero-card-slider__toggle-state', function() {
        if ( $( this ).hasClass( 'is-paused' ) ) {
          $( this ).attr( 'aria-label', 'Pause slider' );
          $( this ).find( '.icon-play' ).hide().attr( 'aria-hidden', 'true' );
          $( this ).find( '.icon-pause' ).show().attr( 'aria-hidden', 'false' );
          $( this ).removeClass( 'is-paused' );
          forcePause = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ? true : false;
          $( '.hero-card-slider .card' ).attr( 'aria-live', 'polite' );
          resumeToNextSlide();
        } else {
          $( this ).attr( 'aria-label', 'Play slider' );
          $( this ).find( '.icon-play' ).show().attr( 'aria-hidden', 'false' );
          $( this ).find( '.icon-pause' ).hide().attr( 'aria-hidden', 'true' );
          $( this ).addClass( 'is-paused' );
          forcePause = true;
          window.clearInterval( autorotate ); // pause
          $( '.hero-card-slider .card' ).attr( 'aria-live', 'polite' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-card-slider', COMPONENT );
} )( app );
